<template>
  <v-dialog v-model="localShowDialog" max-width="500px">
    <v-card>
      <v-app-bar color="secondary" dark flat dense>
        <span>Assign permissions</span>
        <v-spacer />
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-text class="pt-6">
        <v-row>
          <v-col cols="12">
            Each User Role is composed of multiple permissions. Please note: When adding or amending permissions, this will impact the User Role across all Whizeo accounts
          </v-col>
          
          <v-col cols="12">
            <v-text-field
              v-model="searchText"
              label="Search for permission"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <permission-checkbox
              v-for="permission in filteredPermissions"
              :key="permission.permissionId"
              :permission="permission"
              :roleId="roleId"
              :checked="selectedPermissionsIds.includes(permission.permissionId)"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" color="primary">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
  
<script>
import { mapActions } from "vuex";
import PermissionCheckbox from "./PermissionCheckbox.vue";

export default {
  components: { PermissionCheckbox },
  emits: ["close", "submit"],
  props: {
    // Role ID
    roleId: {
      type: Number,
      default: 0,
    },
    // Boolean to control dialog visibility
    showDialog: {
      type: Boolean,
    },
    // List of available permissions
    permissions: {
      type: Array,
      default: () => [],
    },
    // List of assigned permissions to this role
    selectedPermissionsIds: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    localShowDialog: false,
    searchText: '',
  }),
  methods: {
    ...mapActions("whizeosupportToolsStore", ["SHOW_SNACKBAR"]),
    close() {
      this.$emit("close");
    },
  },
  computed: {
    filteredPermissions() {
      const permissions = this.permissions.filter((permission) => permission.name.toLowerCase().includes(this.searchText.toLowerCase()));
      return permissions;
    }
  },
  watch: {
    localShowDialog(newVal) {
      if (!newVal) {
        this.close();
      }
    }
  },
  mounted() {
    this.localShowDialog = this.showDialog;
  }
};
</script>